// libs
import React, { useContext } from 'react'

// interfaces / constants
import { PROFILES_SEARCH_QUERY_KEY } from 'src/constants/urls'
import { URLContext } from 'src/containers/url_provider/url_provider'

// components
import NavigationItem from 'src/components/navigation_item/navigation_item'
import { Tag } from 'src/components/tag/tag'

interface IProfileTagProps {
  text: string;
  className?: string;
  url?: string;
}

const ProfileTag: React.FC<IProfileTagProps> = ({ text, className, url }) => {
  const { getProfilesDirectoryRoute } = useContext(URLContext)
  const uriEncodedTag = encodeURIComponent(text)
  const queryUrl =
    url ||
    `${getProfilesDirectoryRoute()}?${PROFILES_SEARCH_QUERY_KEY}=${uriEncodedTag}`

  return (
    <NavigationItem url={queryUrl} className={className}>
      <Tag text={text} />
    </NavigationItem>
  )
}

ProfileTag.displayName = 'ProfileTag'

export default ProfileTag
